import '@/lib/HorizontalScroller/horizontal-scroller.scss';
import { initHorizontalScroller } from '@/lib/HorizontalScroller';

// Initialize using the element method installed by the library
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.mini-card-carousel').forEach(function (wrapper) {
    // ensure compatible hs-slider class is present on the slider element so the library styles apply
    var sliderEl = wrapper.querySelector('.mini-card-carousel-slider');
    if (sliderEl && sliderEl.children.length > 1 && !sliderEl.classList.contains('hs-slider')) sliderEl.classList.add('hs-slider');

    // initialize HorizontalScroller using the element API (no selector needed)
    wrapper.HorizontalScroller();
  });
});
